<template lang="pug">
  .modal(v-if="index" v-bind:class="[showModal ? 'popup' : 'hide']" @click="closeModal")
    .modal-wrapper
      .modal-container
        .modal-body
          slot(name='body')
            img(v-bind:src="index.screenshot_original")
        .modal-footer
          a.modal-default-button(v-bind:href="index.url" target="_blank") 詳しく見る

</template>

<script>

// import api from '../../service/api.js'
// import { vm } from "../../service/bus"
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
export default{
  // data: function(){
  //   return{
  //     index: null,
  //     showModal: false
  //   }
  // },
  // created () {
  //   vm.$on('toggle-modal', this.showPage);
  // },
  computed: {
    ...mapState([
      'indices',
      'index',
      'showModal'
    ]),
    // ...mapGetters(['index']),
    // message() {
    //   return this.$store.getters.index
    //   console.log(this.$store.getters.index);
    // }
  },
  methods: {
    ...mapMutations({
      toggleModal:'toggleModal'
    }),
    closeModal: function(){
        // this.index = this.$store.state.index
      const el = document.body;
      el.classList.remove("noscroll");
      this.toggleModal();
    },
    // showPage: function(id){
    //   vm.$emit('loading');

    //   api.getIndex(id).then((response) => {
    //     const el = document.body;
    //     el.classList.add("noscroll");
    //     this.index = {};
    //     this.index = response.data.indices[0].indices;
    //     var modal = document.getElementsByClassName('modal')[0];
    //     modal.scrollIntoView(true);
    //     this.sleep(1000);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   })
    //   .then(() => {
    //     vm.$emit('loaded');
    //     this.showModal = true;
    //   });
    // },
    // closeModal: function(){
    //   const el = document.body;
    //   el.classList.remove("noscroll");
    //   this.showModal = false
    // },
    // sleep: function(msec) {
    //   var d1 = new Date();
    //   while (true) {
    //     var d2 = new Date();
    //     if (d2 - d1 > msec) {
    //       break;
    //     }
    //   }
    // }
  }
}
</script>


<style lang="scss" scoped>
@import "../../../assets/stylesheets/variables";

.container{
  .popup{
    z-index: 9999;
    opacity: 1;
    display: block;
    animation-duration: 0.5s;
    animation-name: fade-in;
  }
  .hide{
    opacity: 0;
    display: none;
    animation-duration: 0.5s;
    animation-name: hide;
  }
}

.noscroll{
  overflow: hidden;
}

.modal{
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: none;
  overflow-y: scroll;
}
.modal-admin{
  .modal-body{
    height: 500px;
    overflow: scroll;
  }
}

.modal-wrapper {
  display: flex;
  vertical-align: middle;
  padding: 32px 0;
  @media only screen and( max-width: $tablet){
    padding: 16px;
  }
}

.modal-container {
  width: 1024px;
  @media only screen and( max-width: $tablet){
    width: 100%;
  }
  margin: 0px auto;
  // padding: 20px 30px;
  background: #ccc;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0;
  img{
    width: 100%;
  }
}

.modal-footer{
  margin: $space-l;
  text-align: center;
  padding: 16px;
}

.modal-default-button {
  background: #000;
  color: #fff;
  text-decoration: none;
  padding: $space-m $space-xxl;
  transition: .3s;
  @media only screen and( max-width: $tablet){
    padding: 16px 0;
    width: 100%;
    display: block;
  }
  &:hover{
    opacity: .8;
    transition: .3s;
  }
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@keyframes show{
    from{
        opacity: 0;
        display: none;
    }
    to{
        opacity: 1;
        display: block;
    }
}

@keyframes hide{
    from{
        opacity: 1;
        // display: block;
    }
    to{
        opacity: 0;
        // display: none;
    }
}

@keyframes fade-in {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    display: block;
    opacity: 1;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: none;
    opacity: 0;
  }
}

</style>
